export class Email {
    static NO_REPLY_ADDRESS = 'no-reply@legal25.com'
    static UTF8 = 'UTF-8'
}

export default Email
